export default __webpack_public_path__ + "img/8aed152aa2d4d93c59262057f6f23eab.png";